import React from 'react';
import { Dropdown, Grid, Input, Segment } from 'semantic-ui-react';

import { CustomDropDownOptions } from '../../../types';
import { FieldLabel } from '../../../styles';
import Button from '../../../components/Button';
import { maskCpfOrCnpj } from '../../../services/masks';

import { FiltersState } from '../types';

type Props = {
  isEstateUser: boolean;
  estateOptions: Array<{ key: string; text: string; value: string }>;
  filters: FiltersState;
  setFilters: React.Dispatch<React.SetStateAction<FiltersState>>;
  statusOptions: Array<{ key: string; value: string; text: string }>;
  onSearch: () => void;
  onClear: () => void;
};

const FiltersBar: React.FC<Props> = ({
  isEstateUser,
  estateOptions,
  filters,
  setFilters,
  statusOptions,
  onSearch,
  onClear
}) => {
  return (
    <Segment>
      <Grid>
        <Grid.Row>
          {!isEstateUser && (
            <Grid.Column computer={4} tablet={16} mobile={16}>
              <FieldLabel>Imobiliária</FieldLabel>
              <div style={{ width: '100%' }}>
                <Dropdown
                  style={{ width: '100%' }}
                  value={filters.estateId || ''}
                  placeholder="Selecionar..."
                  options={estateOptions}
                  search
                  selection
                  clearable
                  onChange={(_, { value }) =>
                    setFilters(prev => ({ ...prev, estateId: (value as string) || '' }))
                  }
                />
              </div>
            </Grid.Column>
          )}

          <Grid.Column computer={4} tablet={16} mobile={16}>
            <FieldLabel>Pesquisar por</FieldLabel>
            <div style={{ width: '100%' }}>
              <Dropdown
                style={{ width: '100%' }}
                value={filters.type}
                placeholder="Selecionar..."
                options={[
                  { key: 'payer', value: 'payer', text: 'Nome' },
                  { key: 'document', value: 'document', text: 'CPF' },
                  { key: 'email', value: 'email', text: 'E-mail' }
                ]}
                search
                selection
                onChange={(_, { value }) =>
                  setFilters(prev => ({
                    ...prev,
                    type: value as FiltersState['type'],
                    argument: ''
                  }))
                }
              />
            </div>
          </Grid.Column>

          <Grid.Column computer={8} tablet={16} mobile={16}>
            <FieldLabel>Termo de pesquisa</FieldLabel>
            <Input
              fluid
              value={filters.argument}
              onChange={(_, { value }) => {
                if (filters.type === 'document') {
                  setFilters(prev => ({ ...prev, argument: maskCpfOrCnpj(value) }));
                  return;
                }
                setFilters(prev => ({ ...prev, argument: value }));
              }}
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column computer={4} tablet={16} mobile={16}>
            <FieldLabel>Status</FieldLabel>
            <div style={{ width: '100%' }}>
              <Dropdown
                style={{ width: '100%' }}
                value={filters.status || ''}
                placeholder="Selecionar..."
                options={statusOptions}
                search
                selection
                clearable
                onChange={(_, { value }) =>
                  setFilters(prev => ({ ...prev, status: (value as string) || '' }))
                }
              />
            </div>
          </Grid.Column>

          <Grid.Column computer={4} tablet={16} mobile={16}>
            <FieldLabel>Data Inicial</FieldLabel>
            <Input
              fluid
              type="date"
              value={filters.startDate}
              onChange={(_, { value }) => setFilters(prev => ({ ...prev, startDate: value }))}
            />
          </Grid.Column>

          <Grid.Column computer={4} tablet={16} mobile={16}>
            <FieldLabel>Data Final</FieldLabel>
            <Input
              fluid
              type="date"
              value={filters.endDate}
              onChange={(_, { value }) => setFilters(prev => ({ ...prev, endDate: value }))}
            />
          </Grid.Column>

          <Grid.Column computer={4} tablet={16} mobile={16}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, paddingTop: 14 }}>
              <Button type="submit" text="Pesquisar" onClick={() => onSearch()} />
              <Button light type="button" text="Limpar" onClick={onClear} />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default FiltersBar;

